import {
  AIRLINES_FETCH_SUCCESS,
  AIRLINES_FETCH_FAILED,
  AIRLINES_FETCH_DATA,
} from "src/redux/actions/airlines";

type AirlineImage = {
  Image: string;
  Name: string;
  SecondaryImage: string;
};

export type AirlineCodes = {
  [key: string]: AirlineImage;
};

export interface AirlineState {
  loading?: boolean;
  error?: Error;
  images?: AirlineCodes;
}

export const initialState: AirlineState = {
  loading: false,
  error: null,
};

type AirlinesFetchAction = {
  type: typeof AIRLINES_FETCH_DATA;
};

type AirlinesFetchSuccessAction = {
  type: typeof AIRLINES_FETCH_SUCCESS;
  payload?: {
    airlineCodes: AirlineCodes;
  };
};

type AirlinesFetchFailedAction = {
  type: typeof AIRLINES_FETCH_FAILED;
  error: Error;
};

export type AirlinesAction =
  | AirlinesFetchAction
  | AirlinesFetchSuccessAction
  | AirlinesFetchFailedAction;

const airlines = (
  state = initialState,
  action: AirlinesAction
): AirlineState => {
  switch (action.type) {
    case AIRLINES_FETCH_SUCCESS:
      return {
        loading: false,
        error: null,
        images: action.payload.airlineCodes,
      };

    case AIRLINES_FETCH_FAILED:
      return {
        loading: false,
        error: action.error,
        images: null,
      };

    default:
      return state;
  }
};

export default airlines;
